import { Text, Button, Popover, Grid, GridCol } from '@mantine/core';
import { useFormContext } from '../../../contexts/formContext';
import { TextureFormatSelect } from './TextureFormatSelect';
import { TextureFormatOption } from '../utils/getAllowedTextureFormats';

type TexturesModalProps = {
  fileNumber: number;
  allowedTextureFileFormats: TextureFormatOption[];
};

export function CustomisedTextureFormatSelection({ fileNumber, allowedTextureFileFormats }: TexturesModalProps) {
  const form = useFormContext();
  const formPath = `compressionAndExport.fileExports.${fileNumber}.textureFormat`;

  const textureFileFormats = allowedTextureFileFormats.filter((format) => format.value !== 'custom');

  return (
    <Popover width={400} position='bottom' withArrow shadow='md'>
      <Popover.Target>
        <Button variant='default' onClick={() => open()}>
          Customize
        </Button>
      </Popover.Target>
      <Popover.Dropdown>
        <Grid>
          <GridCol span={4}>
            <Text>Base Color</Text>
          </GridCol>
          <GridCol span={8}>
            <TextureFormatSelect options={textureFileFormats} {...form.getInputProps(`${formPath}.baseColor`)} />
          </GridCol>
          <GridCol span={4}>
            <Text>Emissive</Text>
          </GridCol>
          <GridCol span={8}>
            <TextureFormatSelect options={textureFileFormats} {...form.getInputProps(`${formPath}.emissive`)} />
          </GridCol>
          <GridCol span={4}>
            <Text>Normal</Text>
          </GridCol>
          <GridCol span={8}>
            <TextureFormatSelect options={textureFileFormats} {...form.getInputProps(`${formPath}.normal`)} />
          </GridCol>
          <GridCol span={4}>
            <Text>Orm</Text>
          </GridCol>
          <GridCol span={8}>
            <TextureFormatSelect options={textureFileFormats} {...form.getInputProps(`${formPath}.orm`)} />
          </GridCol>
        </Grid>
      </Popover.Dropdown>
    </Popover>
  );
}
